export const ERROR_AVANCE_LIST = 'channelmap/avanceventasgalones/error-avance-list';
export const RECEIVE_AVANCE_LIST = 'channelmap/avanceventasgalones/receive-avance-list';
export const REQUEST_AVANCE_LIST = 'channelmap/avanceventasgalones/request-avance-request';
export const RESTART_STATE = 'channelmap/avanceventasgalones/restart_state';
export const SET_MASK = 'channelmap/avanceventasgalones/set-mask';
export const SET_ORDER = 'channelmap/avanceventasgalones/set-order';
export const SET_SELECTED_ROW = 'channelmap/avanceventasgalones/set-selected-row';
export const UPDATE_FIELD_FILTER = 'channelmap/avanceventasgalones/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'channelmap/avanceventasgalones/set-selected-row';